import { useEffect, useState } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { Image, Heading, Text } from "@chakra-ui/react";
import styles from "./MarketPlace.module.css";
import ReadMoreReadLess from "react-read-more-read-less";
import { useNavigate } from "react-router-dom";
import { canSee } from "../../utils/sectionPermissions";
import { Form } from "react-bootstrap";
import { CircularProgress, Box, TextField } from "@mui/material";
import MarketPlaceDetail from "./MarketPlaceDetail/MarketPlaceDetails.js";
import { ReactComponent as NoAccess } from "../../img/svg/NoAccess.svg";
import DynamicDialog from "../../store/DynamicDialog/DynamicDialog.tsx";
import ListToWebsiteModal from "./ListToWebsiteModal.js";

const MarketPlace = (props) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [tags, setTags] = useState("");
  const [logoLink, setLogoLink] = useState("");
  const [info, setInfo] = useState("");
  const [mainEmail, setMainEmail] = useState("");
  const [billingEmail, setBillingEmail] = useState("");
  const [billingType, setBillingType] = useState("monthly");
  const [netPayment, setNetPayment] = useState("");
  const [status, setStatus] = useState("Active");
  const [showAddForm, setAddFormShow] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [triggerMarketPlace, setTriggerMarketPlace] = useState(false);
  const [selectedMarketPlace, setSelectedMarketPlace] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [showRemoveDialog, setShowRemoveDialog] = useState(false);
  const [removeId, setRemoveId] = useState(null);
  const [showDuplicateDialog, setShowDuplicateDialog] = useState(false);
  const [duplicateId, setDuplicateId] = useState(null);
  const [showListDialog, setShowListDialog] = useState(false);
  const [listId, setListId] = useState(null);
  const [postLoader, setPostLoader] = useState(false);
  //LOADER:
  const [marketPlaceLoader, setMarketPlaceLoader] = useState(false);
  const [editSubmitLoader, setEditSubmitLoader] = useState(false);
  const [addFormSubmitLoader, setAddSubmitLoader] = useState(false);
  // USEEFFECT
  useEffect(() => {
    setMarketPlaceLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/marketplace/get`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "GET",
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 201) {
          console.log("DATA NOT FETCHED");
        } else if (response.status === 202) {
          navigate("/login");
        }
      })
      .then((data) => {
        setItems(data);
        setMarketPlaceLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setMarketPlaceLoader(false);
      });
  }, [triggerMarketPlace, navigate]);
  //ADD FORM HANDLERS:
  const addFormOpenHandler = () => {
    setName("");
    setVendorName("");
    setStartDate("");
    setMainEmail("");
    setBillingEmail("");
    setBillingType("monthly");
    setNetPayment("");
    setStatus("Active");
    setLogoLink("");
    setInfo("");
    setTags("");
    setAddFormShow(true);
  };
  const addFormCloseHandler = () => {
    setAddFormShow(false);
    setAddSubmitLoader(false);
  };
  //EDIT FORM HANDLERS // SETTING UP DATA ON CLICKING ON EDIT // OPEN EDIT FORM :
  const editFormOpenHandler = (item) => {
    setId(item.id);
    setName(item.name);
    setLogoLink(item.logoLink);
    setInfo(item.info);
    setVendorName(item.vendor_name);
    setMainEmail(item.main_email);
    setBillingEmail(item.billing_email);
    setBillingType(item.billing_type);
    setNetPayment(item.net_payment);
    setStatus(item.status);
    setStartDate(formatDate(item.start_date));
    setTags(toTagString(item.type2));
    setShowEditForm(true);
  };

  // type2 is a JSON column but rows are inconsistent: admin products store a
  // real array, vendor-listed products can store a raw/stringified value. A
  // plain `item.type2?.join` crashed (".join is not a function") on those rows,
  // so the edit form never opened for vendor-owned products. Normalise to a
  // comma string regardless of shape.
  const toTagString = (t) => {
    if (Array.isArray(t)) return t.join(",");
    if (typeof t === "string") {
      try {
        const parsed = JSON.parse(t);
        if (Array.isArray(parsed)) return parsed.join(",");
      } catch (e) {
        /* not JSON — treat as a plain comma string */
      }
      return t;
    }
    return "";
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  const editFormCloseHandler = () => {
    setEditSubmitLoader(false);
    setShowEditForm(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAddSubmitLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/marketplace/create`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        name: name,
        vendor_name: vendorName,
        start_date: startDate,
        main_email: mainEmail,
        billing_email: billingEmail,
        billing_type: billingType,
        net_payment: netPayment,
        type2: tags.split(","),
        logoLink: logoLink,
        info: info,
        status: status,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          console.log("add form created");
          setAddSubmitLoader(false);
          setTriggerMarketPlace(!triggerMarketPlace);
          addFormCloseHandler();
          return response.json();
        } else if (response.status === 201) {
          console.log("not posted");
          setAddSubmitLoader(false);
          setTriggerMarketPlace(!triggerMarketPlace);
        } else if (response.status === 202) {
          navigate("/login");
        }
      })
      .catch((err) => {
        console.log(err);
        setAddSubmitLoader(false);
        setTriggerMarketPlace(!triggerMarketPlace);
      });
  };

  const editSubmitHandler = (e) => {
    e.preventDefault();
    setEditSubmitLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/marketplace/update`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        id: id,
        name: name,
        vendor_name: vendorName,
        start_date: startDate,
        main_email: mainEmail,
        billing_email: billingEmail,
        billing_type: billingType,
        net_payment: netPayment,
        type2: tags.split(","),
        logoLink: logoLink,
        info: info,
        status: status,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          console.log("Edit form posted");
          setEditSubmitLoader(false);
          setTriggerMarketPlace(!triggerMarketPlace);
          editFormCloseHandler();
        } else if (response.status === 201) {
          console.log("not posted");
          setEditSubmitLoader(false);
          setTriggerMarketPlace(!triggerMarketPlace);
        } else if (response.status === 202) {
          navigate("/login");
        } else {
          // 400/500 from the API — surface it instead of spinning forever.
          setEditSubmitLoader(false);
          response
            .json()
            .then((d) =>
              alert(d?.msg ? `Update failed: ${d.msg}` : "Update failed"),
            )
            .catch(() => alert("Update failed"));
        }
      })
      .catch((err) => {
        console.log(err);
        setEditSubmitLoader(false);
        setTriggerMarketPlace(!triggerMarketPlace);
      });
  };

  const handleSelectMarketPlace = (item) => {
    setSelectedMarketPlace(item);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handlePaymentStatusChange = (event) => {
    setPaymentStatus(event.target.value);
  };

  const filteredAppsData = items.filter((key) => {
    const matchesSearchQuery =
      searchQuery === "" ||
      key.name.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesPaymentStatus =
      paymentStatus === "" ||
      (paymentStatus === "Active" && key.status === "Active") ||
      (paymentStatus === "Out Of Stock" && key.status === "Out Of Stock") ||
      (paymentStatus === "Inactive" && key.status === "Inactive");
    return matchesSearchQuery && matchesPaymentStatus;
  });

  const removeHandlerClicked = (id) => {
    setShowRemoveDialog(true);
    setRemoveId(id);
  };

  const handleRemoveInvite = async () => {
    setPostLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/marketplace/remove`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        id: removeId,
      }),
    }).then(() => {
      setPostLoader(false);
      setShowRemoveDialog(false);
      setTriggerMarketPlace(!triggerMarketPlace);
    });
  };

  const duplicateHandlerClicked = (id) => {
    setShowDuplicateDialog(true);
    setDuplicateId(id);
  };

  const handleDuplicateData = async () => {
    setPostLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/marketplace/duplicate`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        id: duplicateId,
        level: 0,
        parent_id: null,
      }),
    }).then(() => {
      setPostLoader(false);
      setShowDuplicateDialog(false);
      setTriggerMarketPlace(!triggerMarketPlace);
    });
  };

  const listToWebsiteClicked = (id) => {
    setShowListDialog(true);
    setListId(id);
  };

  const handleListData = async (sub_category_id, price_ids) => {
    setPostLoader(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/admin/marketplace/list`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        id: listId,
        sub_category_id: sub_category_id,
        // The plans the admin ticked. Omitting this publishes every active
        // plan, which will happily push leftover test rows to a public page.
        price_ids: price_ids || [],
      }),
    })
      .then((r) => r.json())
      .then((body) => {
        setPostLoader(false);
        setShowListDialog(false);
        setTriggerMarketPlace(!triggerMarketPlace);
        if (body && body.success === false) {
          alert(body.msg || "Listing failed");
        }
      })
      .catch((error) => {
        console.log(error);
        setPostLoader(false);
      });
  };

  return (
    <>
      {canSee(props.userRole, "marketplace") && (
        <>
          {Object.keys(selectedMarketPlace).length === 0 && (
            <>
              {marketPlaceLoader && (
                <CircularProgress
                  size={40}
                  className={styles.circularProgressMain}
                />
              )}
              {!marketPlaceLoader && (
                <ChakraProvider>
                  <div className={styles.mainContainer}>
                    <div className={styles.outerAddForm}>
                      <TextField
                        id="filled-basic"
                        type="text"
                        placeholder="Search by name"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        sx={{ width: "25%" }}
                      />
                      <select
                        name="status"
                        value={paymentStatus}
                        onChange={handlePaymentStatusChange}
                        className={styles.selectFilter}
                      >
                        <option value="">All</option>
                        <option value="Active">Active</option>
                        <option value="Out Of Stock">Out Of Stock</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                      {/*
                      <button
                        className={styles.addForm}
                        onClick={addFormOpenHandler}
                      >
                        Add Company
                      </button>
                      */}
                    </div>
                    <ul className={styles.ulContainer}>
                      {filteredAppsData &&
                        filteredAppsData.map((item) => (
                          <li>
                            <div
                              key={item.id}
                              className={styles.cardContainer}
                              onClick={() => handleSelectMarketPlace(item)}
                            >
                              <div className={styles.bodyContainer}>
                                <div className={styles.imageContainer}>
                                  <Image
                                    className={styles.image}
                                    src={item.logoLink}
                                    alt={item.name}
                                    borderRadius="lg"
                                  />
                                  <h1
                                    className={
                                      item.status === "Active"
                                        ? styles.active
                                        : item.status === "Out Of Stock"
                                          ? styles.outofstock
                                          : styles.inactive
                                    }
                                  >
                                    {item.status}
                                  </h1>
                                </div>
                                {item.vendor_status === "multiple" && (
                                  <h1 className={styles.inactive}>
                                    Multi Vendor Product
                                  </h1>
                                )}
                                <h1 className={styles.active}>
                                  Owned by: {item.owner_name}
                                </h1>
                                <div className={styles.dataContainer}>
                                  <Heading className={styles.productName}>
                                    {item.name}
                                  </Heading>
                                  <Text className={styles.descriptionContainer}>
                                    {item.info ? (
                                      <ReadMoreReadLess
                                        charLimit={100}
                                        readMoreText={
                                          <button
                                            style={{ color: "#3182ce" }}
                                            onClick={() =>
                                              handleSelectMarketPlace(item)
                                            }
                                          >
                                            Read More
                                          </button>
                                        }
                                        readLessText={"Read Less"}
                                      >
                                        {item.info}
                                      </ReadMoreReadLess>
                                    ) : (
                                      <Text>No information available</Text>
                                    )}
                                  </Text>
                                  <div className={styles.buttonGroup}>
                                    <button
                                      className={styles.editButton}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        editFormOpenHandler(item);
                                      }}
                                    >
                                      Edit
                                    </button>
                                    <button
                                      className={styles.removeButton}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        removeHandlerClicked(item.id);
                                      }}
                                    >
                                      Remove
                                    </button>
                                    <button
                                      className={styles.duplicateButton}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        duplicateHandlerClicked(item.id);
                                      }}
                                    >
                                      Duplicate
                                    </button>
                                    <button
                                      className={styles.listButton}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        listToWebsiteClicked(item.id);
                                      }}
                                    >
                                      List to Website
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </ChakraProvider>
              )}

              {/* ADD FORM DIALOG MODAL */}

              {showAddForm && (
                <>
                  {" "}
                  <div
                    className={styles.backdrop}
                    onClick={addFormCloseHandler}
                  ></div>
                  <div
                    onHide={addFormCloseHandler}
                    className={styles.modalContainer}
                  >
                    <h2 className={styles.marketPlaceHeading}>
                      Add Marketplace Details
                    </h2>
                    <Form className={styles.mainForm}>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Enter name"
                          className={styles.formControl}
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Image Link</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={logoLink}
                          onChange={(e) => setLogoLink(e.target.value)}
                          placeholder="Enter Image Link"
                          className={styles.formControl}
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={info}
                          onChange={(e) => setInfo(e.target.value)}
                          placeholder="Enter Description"
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formVendorName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Vendor Name</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={vendorName}
                          onChange={(e) => setVendorName(e.target.value)}
                          placeholder="Enter vendor name"
                          className={styles.formControl}
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formStartDate"
                        className={styles.formGroup}
                      >
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          required
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          className={styles.formControl}
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formStartDate"
                        className={styles.formGroup}
                      >
                        <Form.Label>
                          Tags (Write all tags comma(,) seperated)
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={tags}
                          onChange={(e) => setTags(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formMainEmail"
                        className={styles.formGroup}
                      >
                        <Form.Label>Main Email</Form.Label>
                        <Form.Control
                          required
                          type="email"
                          value={mainEmail}
                          onChange={(e) => setMainEmail(e.target.value)}
                          placeholder="Enter main email"
                          className={styles.formControl}
                        />
                      </Form.Group>

                      <Form.Group
                        controlId="formBillingEmail"
                        className={styles.formGroup}
                      >
                        <Form.Label>Billing Email</Form.Label>
                        <Form.Control
                          required
                          type="email"
                          value={billingEmail}
                          onChange={(e) => setBillingEmail(e.target.value)}
                          placeholder="Enter billing email"
                          className={styles.formControl}
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formBillingType"
                        className={styles.formGroup}
                      >
                        <Form.Label>Billing Type</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          value={billingType}
                          onChange={(e) => setBillingType(e.target.value)}
                          className={styles.formControl}
                        >
                          <option value="monthly">Monthly</option>
                          <option value="sum">Sum</option>
                          <option value="net">Net</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group
                        controlId="formNetPayment"
                        className={styles.formGroup}
                      >
                        <Form.Label>Net Payment</Form.Label>
                        <Form.Control
                          required
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          value={netPayment}
                          onChange={(e) => setNetPayment(e.target.value)}
                          placeholder="Enter net payment"
                          className={styles.formControl}
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formStatus"
                        className={styles.formGroup}
                      >
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                          className={styles.formControl}
                        >
                          <option value="Active">Active</option>
                          <option value="Out Of Stock">Out of Stock</option>
                          <option value="Inactive">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                      <button
                        onClick={handleSubmit}
                        variant="primary"
                        type="submit"
                        className={styles.submitButton}
                      >
                        {addFormSubmitLoader ? (
                          <CircularProgress size={20} sx={{ color: "white" }} />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </Form>
                  </div>{" "}
                </>
              )}

              {/* EDIT FORM DIALOG */}
              {showEditForm && (
                <>
                  {" "}
                  <div
                    className={styles.backdrop}
                    onClick={editFormCloseHandler}
                  ></div>
                  <div
                    onHide={addFormCloseHandler}
                    className={styles.modalContainer}
                  >
                    <Form className={styles.mainForm}>
                      <h2 className={styles.marketPlaceHeading}>
                        Edit MarketPlace Details
                      </h2>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Enter name"
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Image URL</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={logoLink}
                          onChange={(e) => setLogoLink(e.target.value)}
                          placeholder="Enter Link to Image"
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={info}
                          onChange={(e) => setInfo(e.target.value)}
                          placeholder="Enter Description"
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formVendorName"
                        className={styles.formGroup}
                      >
                        <Form.Label>Vendor Name</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={vendorName}
                          onChange={(e) => setVendorName(e.target.value)}
                          placeholder="Enter vendor name"
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formStartDate"
                        className={styles.formGroup}
                      >
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          required
                          type="date"
                          value={startDate}
                          onChange={(e) => {
                            console.log("bootstrap date", e.target.value);
                            setStartDate(e.target.value);
                          }}
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formStartDate"
                        className={styles.formGroup}
                      >
                        <Form.Label>
                          Tags (Write all tags comma(,) seperated)
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          value={tags}
                          onChange={(e) => setTags(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formMainEmail"
                        className={styles.formGroup}
                      >
                        <Form.Label>Main Email</Form.Label>
                        <Form.Control
                          required
                          type="email"
                          value={mainEmail}
                          onChange={(e) => setMainEmail(e.target.value)}
                          placeholder="Enter main email"
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formBillingEmail"
                        className={styles.formGroup}
                      >
                        <Form.Label>Billing Email</Form.Label>
                        <Form.Control
                          required
                          type="email"
                          value={billingEmail}
                          onChange={(e) => setBillingEmail(e.target.value)}
                          placeholder="Enter billing email"
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formBillingType"
                        className={styles.formGroup}
                      >
                        <Form.Label>Billing Type</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          value={billingType}
                          onChange={(e) => setBillingType(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        >
                          <option value="monthly">Monthly</option>
                          <option value="sum">Sum</option>
                          <option value="net">Net</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group
                        controlId="formNetPayment"
                        className={styles.formGroup}
                      >
                        <Form.Label>Net Payment</Form.Label>
                        <Form.Control
                          required
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          value={netPayment}
                          onChange={(e) => setNetPayment(e.target.value)}
                          placeholder="Enter net payment"
                          className={styles.formControl} // Ensure this class is applied
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formStatus"
                        className={styles.formGroup}
                      >
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                          className={styles.formControl} // Ensure this class is applied
                        >
                          <option value="Active">Active</option>
                          <option value="Out Of Stock">Out of Stock</option>
                          <option value="Inactive">Inactive</option>
                        </Form.Control>
                      </Form.Group>
                      {/* type="button" (not submit) so the admin can edit/
                          disable ANY product — including vendor-owned ones whose
                          billing fields (main/billing email, start date, net
                          payment) are empty — without HTML5 required-validation
                          blocking the save. The BE only persists fields that
                          carry a real value. */}
                      <button
                        variant="primary"
                        type="button"
                        className={styles.submitButton}
                        onClick={editSubmitHandler}
                      >
                        {editSubmitLoader ? (
                          <CircularProgress size={20} sx={{ color: "white" }} />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </Form>
                  </div>{" "}
                </>
              )}
            </>
          )}
          {Object.keys(selectedMarketPlace).length !== 0 && (
            <MarketPlaceDetail
              selectedMarketPlace={selectedMarketPlace}
              setSelectedMarketPlace={setSelectedMarketPlace}
            />
          )}
        </>
      )}
      {!canSee(props.userRole, "marketplace") && (
        <Box>
          <div>
            <center>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <NoAccess style={{ height: "50vh" }}></NoAccess>
              </Box>
            </center>
          </div>
        </Box>
      )}

      <DynamicDialog
        isOpen={showRemoveDialog}
        onClose={() => setShowRemoveDialog(false)}
        title="Are you sure you want to Delete (All Child Data Will Be Lost)?"
        title2=""
        description={[]}
        Loader={postLoader}
        fields={[]}
        buttons={[
          {
            label: "Cancel",
            onClick: () => setShowRemoveDialog(false),
          },
          {
            label: "Delete",
            onClick: () => {
              handleRemoveInvite();
            },
          },
        ]}
      />

      <DynamicDialog
        isOpen={showDuplicateDialog}
        onClose={() => setShowDuplicateDialog(false)}
        title="Are you sure you want to Duplicate (All Child Data Will Be Duplicated)?"
        title2=""
        description={[]}
        Loader={postLoader}
        fields={[]}
        buttons={[
          {
            label: "Cancel",
            onClick: () => setShowDuplicateDialog(false),
          },
          {
            label: "Confirm",
            onClick: () => {
              handleDuplicateData();
            },
          },
        ]}
      />

      {showListDialog && (
        <ListToWebsiteModal
          onClose={() => setShowListDialog(false)}
          handleListData={handleListData}
          postLoader={postLoader}
          marketPlaceId={listId}
        />
      )}

      {/* <DynamicDialog
        isOpen={showListDialog}
        onClose={() => setShowListDialog(false)}
        title="Are you sure you want to List to Website (All Child Data Will Be Listed)?"
        title2=""
        description={[]}
        Loader={postLoader}
        fields={[]}
        buttons={[
          {
            label: "Cancel",
            onClick: () => setShowListDialog(false),
          },
          {
            label: "Confirm",
            onClick: () => {
              handleListData();
            },
          },
        ]}
      /> */}
    </>
  );
};

export default MarketPlace;
